import { useAppSelector } from '../../effects/useAppSelector';
import { constants } from '../../constants';

interface AnalystLabelProps {
    analystUserId?: number;
}

export function AnalystLabel({ analystUserId }: AnalystLabelProps) {
    const user = useAppSelector(s => analystUserId ? s.entities.cloManagerUsers.items[analystUserId] : undefined);

    if (!user) return <>{constants.emptyPlaceholder}</>;

    const label = `${user.firstName} ${user.lastName.charAt(0)}.`;
    return <span>{label}</span>;
}
